import React, { useState, useMemo } from 'react';
import { ChevronDown, X } from 'lucide-react';

export default function CountryFilter({ countries, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    if (!search) return countries.slice(0, 30);
    const q = search.toLowerCase();
    return countries.filter(c => c.country.toLowerCase().includes(q)).slice(0, 30);
  }, [countries, search]);

  const selectedLabel = value || 'Все страны';

  return (
    <div>
      <label className="block text-xs font-medium text-text-muted mb-1">Страна происхождения</label>
      <div className="relative">
        <button
          onClick={() => setOpen(!open)}
          className="w-full flex items-center justify-between px-2.5 py-1.5 text-sm
                     border border-border-default rounded-lg bg-surface hover:bg-hover transition-colors"
        >
          <span className={value ? 'text-text-primary' : 'text-text-disabled'}>{selectedLabel}</span>
          <div className="flex items-center gap-1">
            {value && (
              <span
                onClick={e => { e.stopPropagation(); onChange(''); setOpen(false); }}
                className="p-0.5 hover:text-red-500 dark:hover:text-red-400"
              >
                <X className="w-3 h-3" />
              </span>
            )}
            <ChevronDown className="w-3.5 h-3.5 text-text-disabled" />
          </div>
        </button>

        {open && (
          <div className="absolute top-full left-0 right-0 mt-1 bg-elevated border border-border-default rounded-lg shadow-lg z-40 max-h-52 overflow-hidden">
            <div className="p-2 border-b border-border-default">
              <input
                type="text"
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Поиск страны..."
                className="w-full px-2 py-1 text-sm bg-app text-text-primary placeholder:text-text-disabled border border-border-default rounded focus:outline-none focus:ring-1 focus:ring-ring-focus"
                autoFocus
              />
            </div>
            <div className="max-h-40 overflow-y-auto">
              {filtered.map(c => (
                <button
                  key={c.country}
                  onClick={() => { onChange(c.country); setOpen(false); setSearch(''); }}
                  className={`
                    w-full text-left px-3 py-1.5 text-sm hover:bg-blue-50 dark:hover:bg-blue-950/40 flex justify-between
                    ${value === c.country ? 'bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300 font-medium' : 'text-text-secondary'}
                  `}
                >
                  <span>{c.country}</span>
                  <span className="text-xs text-text-disabled">{c.count.toLocaleString('ru-RU')}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
